/** Normalize a ZIP value at every client/data boundary. */
export function normalizeZipCode(value: unknown): string {
  if (value === null || value === undefined) return '';

  const digits = String(value)
    .trim()
    .replace(/[^0-9]/g, '');
  if (digits.length >= 9) return digits.slice(0, 5);
  if (digits.length === 5) return digits;
  if (digits.length > 0 && digits.length < 5) return digits.padStart(5, '0');
  return '';
}

export function normalizeZipCodes(values: unknown): string[] {
  if (!Array.isArray(values)) return [];
  return [...new Set(values.map(normalizeZipCode).filter(Boolean))];
}

export function isZipLikeInput(value: string): boolean {
  return /^\d{3,5}(?:[-\s]?\d{4})?$/.test(value.trim());
}
